import { gql } from '@apollo/client';
const SET_ORDER_MODEL_TO_READY = gql `
  mutation SetOrderModelToReady($orderModelId: ID!) {
    setOrderModelToReady(orderModelId: $orderModelId) {
      orderModel {
        id
      }
    }
  }
`;
export default SET_ORDER_MODEL_TO_READY;
